exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quote[data-v-74fce7e7] {\r\n    margin-left: 1em;\n}\n@media only screen and (min-width: 768px) {\n.trip-detail-component .quote[data-v-74fce7e7] {\r\n        margin-left: 0;\n}\n.trip-detail-component .quote.long-description[data-v-74fce7e7] {\r\n        font-size: 14px;\n}\n}\r\n", ""]);

// exports
